export const ACCORDEON_LIST = [
  {
    title: 'Descripción larga',
    content: 'longDescription',
    test: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    text: 'longDescription'

  },
  {
    title: 'Posología',
    content: 'posology',
    test: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,',
    text: 'posology'

  },
  {
    title: 'Precauciones',
    content: 'precautions',
    test: '',
    text: 'precautions'
  }

]
